import React from "react";
import { withStyles } from "@material-ui/core/styles";
import withUser from "../HOC/HOCwithUser.jsx";
import { connect } from "react-redux";
import { compose } from "redux";
import * as actions from "../../actions";
import {
  List,
  ListItem,
  ListItemAvatar,
  Button,
  ListItemSecondaryAction,
  ListItemText,
  CircularProgress,
  Toolbar,
  Card,
  Paper,
  Checkbox,
} from "@material-ui/core";
import ProgressiveImage from "react-progressive-image";
import ContentLoader from "react-content-loader";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";
import {
  getBookingStatusClass,
  ROLE_PROVIDER,
  ROLE_CUSTOMER,
  BOOKING_STATUS_INITIATED,
  BOOKING_STATUS_END,
  PAYMENT_PENDING,
  getBookingPaymentStatus,
  getBookingPaymentStatusClass,
  BOOKING_STATUS_CONFIRMED,
  convertTimestampToDate,
  getDay,
  tConvert,
} from "../../utils/config/constants.js";
import {
  KeyboardArrowDown,
  FilterList,
  ArrowForward,
  Check,
  Close,
  DoneOutline,
  Person,
  LocationCity,
  LocationOn,
  Phone,
  Email,
} from "@material-ui/icons";
import { Redirect, withRouter } from "react-router-dom";
import MenuButton from "../Menu/MenuButton.js";
import {
  BOOKING_VIEW_ALL,
  BOOKING_VIEW_INPROGRESS,
  BOOKING_VIEW_NEW,
  BOOKING_VIEW_COMPLETED,
  BOOKING_VIEW_CANCELLED,
  PROVIDER_BOOKING_VIEW_NO_SHOW,
  PROVIDER_BOOKING_VIEW_Today,
} from "../../utils/config/constants";
import CommentIcon from "@material-ui/icons/Comment";
import IconButton from "@material-ui/core/IconButton";
import { NotificationManager } from "react-notifications";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  inline: {
    display: "inline",
  },
  margin: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: "10px",
  },
});
class BookingList extends React.Component {
  constructor(props) {
    super();
    this.state = {
      listName: "Requested",
      listAction: false,
      page: 1,
      scrollClicked: false,
      detailRender: false,
      bookingSelected: "",
      showScroll: true,
    };
  }
  componentDidMount() {
    this.getData();
  }
  getData = () => {
    console.log("typeeee:::", this.props.location);
  
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.type
    ) {
      // alert(" ---- "+this.props.location.state.type)
      if(this.props.location.state.type == 1){
        this.props.mousamproviderAllBookingListAction({
          type: this.props.location.state.type,
          append: false,
        });
      }else{
        this.actionCallbacks(this.props.location.state.type)
        // this.props.providerBookingListAction({
        //   type: this.props.location.state.type,
        //   append: false,
        // });
      }
     
    } else {
      this.props.providerBookingListAction({
        page: this.state.page,
        append: false,
      });
    }
  };

  renderPromoImage = () => {
    return (
      <div style={{ width: 200, height: 200 }}>
        <ContentLoader
          height={200}
          width={200}
          speed={2}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
        >
          <rect x="0" y="0" rx="2" ry="2" width="200" height="200" />
        </ContentLoader>
      </div>
    );
  };
  handlePageChange = () => {
    this.setState(
      function(previousState) {
        return {
          page: previousState.page + 1,
          scrollClicked: true,
        };
      },
      () => {
        this.setState({ scrollClicked: false });
        // alert(3)
        this.props.mousamproviderAllBookingListAction({
          page: this.state.page,
          append: true,
        });
      }
    );
  };
  renderScrollIcon = () => {
    if (this.state.scrollClicked) {
      return <CircularProgress />;
    } else {
      return (
        <Button variant="fab" color="primary">
          <KeyboardArrowDown onClick={this.handlePageChange} />
        </Button>
      );
    }
  };
  renderDetail = (key) => {
    this.setState({ detailRender: true, bookingSelected: key });
  };
  actionCallbacks = (action) => {
    console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", action);
    this.setState({ listAction: false });
    if (action == 1) {
      // alert(4)
      this.props.mousamproviderAllBookingListAction({
        type: action,
        append: false,
      });
      this.setState({ listName: "Requested" });
    } else if (action == 2) {
        this.props.providerBookingListAction({
            type: action,
            append: false,
          });
      this.setState({ listName: "Confirmed" });
    } else if (action == 3) {
        this.props.providerBookingListAction({
            type: action,
            append: false,
          });
      this.setState({ listName: "Completed" });
    } else if (action == 4) {
        this.props.providerBookingListAction({
            type: action,
            append: false,
          });
      this.setState({ listName: "Cancelled" });
    } else if (action == 7) {
        this.props.providerBookingListAction({
            type: action,
            append: false,
          });
      this.setState({ listName: "No Show" });
    }
    if (action == BOOKING_VIEW_ALL) {
      this.setState({ showScroll: true });
    } else {
      this.setState({ showScroll: false });
    }
  };

  actionCallbacks2 = (action) => {
    console.log("00000000000000000000000000000000");
    console.log(
      "111111111111111111111111111111111111111111",
      this.state.listAction
    );
    console.log(
      "providerTodayBookingList",
      PROVIDER_BOOKING_VIEW_Today,
      action
    );
    if (action == PROVIDER_BOOKING_VIEW_Today) {
      this.setState({ showScroll: true });
    } else {
      this.setState({ showScroll: false });
    }
    // alert("CHECK "+this.state.listAction)
    if (!this.state.listAction) {
      if (this.state.listName == "Requested") {
        this.props.mousamproviderTodayBookingListAction({
          type: action,
          append: false,
        });
      } else if (this.state.listName == "Confirmed") {
        this.props.mousamproviderTodayOtherBookingListAction({
            type: 2,
            append: false,
          });
      } else if (this.state.listName == "Completed") {
        this.props.mousamproviderTodayOtherBookingListAction({
            type: 3,
            append: false,
          });
      } else if (this.state.listName == "Cancelled") {
        this.props.mousamproviderTodayOtherBookingListAction({
            type: 4,
            append: false,
          });
      } else if (this.state.listName == "No Show") {
        this.props.mousamproviderTodayOtherBookingListAction({
            type: 7,
            append: false,
          });
      }
    } else {
      if (this.state.listName == "Requested") {
      // alert(5)
      this.props.mousamproviderAllBookingListAction({
          type: action,
          append: false,
        });
      } else if (this.state.listName == "Confirmed") {
        this.props.providerBookingListAction({
            type: 2,
            append: false,
          });
      } else if (this.state.listName == "Completed") {
        // alert("In")
        this.props.providerBookingListAction({
            type: 3,
            append: false,
          });
      } else if (this.state.listName == "Cancelled") {
        this.props.providerBookingListAction({
            type: 4,
            append: false,
          });
      } else if (this.state.listName == "No Show") {
        this.props.providerBookingListAction({
            type: 7,
            append: false,
          });
      }
    }
  };

  bookingAction = (type, token, price) => {
    // alert("2 ::- "+type)

    // this.setState({ actionLoader: false });
    if (type == 1) {
      this.props.acceptBookingAction(
        { bookingToken: token },
        this.onActionDone
      );
    } else if (type == 2) {
      this.props.rejectBookingAction(
        { bookingToken: token },
        this.onActionDone
      );
    } else if (type == 3) {
      this.props.completeBookingAction(
        { bookingToken: token },
        this.onActionDone
      );
    }
  };
  onActionDone = (success, data) => {
    if (success) {
      this.setState({ actionLoader: false });
      NotificationManager.success(
        <FormattedMessage
          id="actionCompleted"
          defaultMessage="Action Completed"
        />,
        "Success"
      );
      this.getData();
    } else {
      NotificationManager.error(
        <FormattedMessage
          id="blocked"
          defaultMessage="You are blocked by user,so cannot accpeted the booking"
        />,
        "Error"
      );
    }
  };

  renderInitiateActions = (booking) => {
    if (this.state.actionLoader) {
      return <CircularProgress />;
    } else {
      console.log("booking ::", booking);
      return (
        <React.Fragment>
          <div className="col-md-12 col-sm-12 col-xs-12  p-0">
            <IconButton
              aria-label="Accept"
              color="green"
              onClick={() =>
                this.bookingAction(
                  1,
                  booking.token,
                  booking.services[0].servicePrice
                )
              }
            >
              <Check />
            </IconButton>
          </div>
          <div className="col-md-12 col-sm-12 col-xs-12 p-0">
            <IconButton
              aria-label="Accept"
              color="red"
              onClick={() =>
                this.bookingAction(
                  2,
                  booking.token,
                  booking.services[0].servicePrice
                )
              }
            >
              <Close />
            </IconButton>
          </div>
        </React.Fragment>
      );
    }
  };

  renderApproveAction = (booking) => {
    if (this.state.actionLoader) {
      return <CircularProgress />;
    } else {
      return (
        <div className="col-md-12 col-sm-12 col-xs-12 p-0">
          <IconButton
            aria-label="Approve"
            color="green"
            onClick={() =>
              this.bookingAction(
                3,
                booking.token,
                booking.services[0].servicePrice
              )
            }
          >
            <DoneOutline />
          </IconButton>
        </div>
      );
    }
  };

  renderPaymentStatus = (booking) => {
    return (
      <div className={getBookingPaymentStatusClass(booking.payment_status)}>
        <FormattedMessage id="paymentStatus" defaultMessage="Payment Status" />:{" "}
        {getBookingPaymentStatus(booking.payment_status)}
      </div>
    );
  };

  render() {
    const { bookingData, classes, userData, match } = this.props;
    const { formatMessage } = this.props.intl;
    const { page, listAction } = this.state;

    if (this.state.detailRender) {
      this.props.history.push({
        pathname: `/user/booking/detail/${this.state.bookingSelected}`,
        bookingId: this.state.bookingSelected,
      });
    }

    return (
      <div className="tz-2-com tz-2-main">
        <h4 className="d-flex justify-align-between">
          <FormattedMessage
            id="myBookingsNew"
            defaultMessage={`My ${this.state.listName} Bookings`}
          />

          <div className="filter-btn">
            <MenuButton
              items={[
                // {
                //     action: BOOKING_VIEW_ALL,
                //     label: formatMessage({
                //         id: 'booking.allbookings'
                //     })
                // },
                // {
                //     action:   PROVIDER_BOOKING_VIEW_Today,
                //     label: formatMessage({

                //         id: 'booking.TodayBooking'
                //     })
                // },
                {
                  action: BOOKING_VIEW_NEW,
                  label: formatMessage({
                    id: "booking.newbookings",
                  }),
                },
                {
                  action: BOOKING_VIEW_INPROGRESS,
                  label: formatMessage({
                    id: "booking.inprogress",
                  }),
                },
                {
                  action: BOOKING_VIEW_COMPLETED,
                  label: formatMessage({
                    id: "booking.completedbookings",
                  }),
                },
                // {
                //   action: BOOKING_VIEW_CANCELLED,
                //   label: formatMessage({
                //     id: "booking.cancelledbookings",
                //   }),
                // },
                // {
                //   action: PROVIDER_BOOKING_VIEW_NO_SHOW,
                //   label: formatMessage({
                //     id: "booking.NoShow",
                //   }),
                // },
              ]}
              menuId={"bookingMenu"}
              menuCallback={(action) => this.actionCallbacks(action)}
              iconType={FilterList}
            />
          </div>
        </h4>

        <div className="Taody_booking">
          <List>
            <ListItem>
              <ListItemAvatar>
                <Checkbox
                  onChange={(event) => {
                    this.setState({
                      listAction: event.target.checked,
                    });
                    this.actionCallbacks2(event);
                  }}
                  checked={listAction}
                  color="primary"
                />
              </ListItemAvatar>

              <ListItemText
                disableTypography={true}
                primary={
                  <React.Fragment>
                    <h5>Today's Booking</h5>
                  </React.Fragment>
                }
              />
              {/* <ListItemSecondaryAction className="list-text-manage">                     
                                        </ListItemSecondaryAction> */}
            </ListItem>
          </List>
        </div>
        <div className="db-list-com">
          <div className="row">
            <div className="col-md-12">
              {bookingData && bookingData.length > 0 ? (
                <List className={classes.root + " list-check-out"}>
                  {bookingData &&
                    bookingData.length > 0 &&
                    bookingData.map((booking) => {
                      return (
                        <ListItem
                          key={booking.key}
                          className={
                            classes.paper +
                            " home-list-pop list-spac list-check-out-inn list-book-provide"
                          }
                        >
                          <div className="row">
                            <div className="col-md-4 dashboard-booklist-img col-xs-12 col-12">
                              <ListItemAvatar>
                                <ProgressiveImage
                                  delay={2000}
                                  src={booking.bookingImage.medium}
                                  placeholder="promo-image"
                                >
                                  {(src, loading) =>
                                    loading ? (
                                      this.renderPromoImage()
                                    ) : (
                                      <img
                                        className="profile_img"
                                        src={src}
                                        alt="promo image"
                                      />
                                    )
                                  }
                                </ProgressiveImage>
                              </ListItemAvatar>
                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 col-12">
                              <ListItemText
                                className=" home-list-pop-desc inn-list-pop-desc"
                                disableTypography={true}
                                primary={
                                  <React.Fragment>
                                    <h3>
                                      {booking.token} (
                                      {moment(booking.datetime).format(
                                        "MM-DD-YYYY"
                                      )}{" "}
                                      | {getDay(booking.datetime)}{" "}
                                      {tConvert(new Date(booking.datetime))})
                                    </h3>
                                    <h5>
                                      {booking.services.length > 0
                                        ? booking.services[0].service
                                        : ""}
                                    </h5>
                                    {booking.statusId ==
                                      BOOKING_STATUS_INITIATED ||
                                      (booking.statusId ==
                                        BOOKING_STATUS_CONFIRMED && (
                                        <React.Fragment>
                                          {" "}
                                          <p>
                                            <Person />
                                            {booking.customerAddress.name}
                                          </p>
                                          <p>
                                            <LocationOn />
                                            {
                                              booking.customerAddress
                                                .address_line1
                                            }
                                          </p>
                                          <p>
                                            <Phone />
                                            {
                                              booking.customerAddress.phone
                                            }, <Email />
                                            {booking.customerAddress.email}
                                          </p>
                                        </React.Fragment>
                                      ))}
                                  </React.Fragment>
                                }
                                secondary={
                                  <React.Fragment>
                                    {booking.provider}
                                    <br />
                                    {this.renderPaymentStatus(booking)}
                                    <br />
                                    <div
                                      className={getBookingStatusClass(
                                        booking.status
                                      )}
                                    >
                                      <FormattedMessage
                                        id="bookingStatus"
                                        defaultMessage="Booking Status"
                                      />
                                      : {booking.status}
                                    </div>
                                    <br />
                                    {moment(booking.datetime).format(
                                      "MM-DD-YYYY"
                                    )}
                                  </React.Fragment>
                                }
                              />
                            </div>
                            <div className="col-md-1 col-sm-1 col-xs-12 col-12 pr-0  icon_div">
                              <IconButton
                                color="primary"
                                aria-label="Detail"
                                onClick={() => this.renderDetail(booking.key)}
                              >
                                <ArrowForward />
                              </IconButton>

                              {booking.statusId == BOOKING_STATUS_INITIATED && (
                                <React.Fragment>
                                  {this.renderInitiateActions(booking)}
                                </React.Fragment>
                              )}
                              {booking.statusId == BOOKING_STATUS_END &&
                                booking.payment_status == PAYMENT_PENDING && (
                                  <React.Fragment>
                                    {/* {this.renderApproveAction(
                                                                booking
                                                            )} */}
                                  </React.Fragment>
                                )}
                            </div>
                          </div>
                        </ListItem>
                      );
                    })}
                </List>
              ) : (
                <Paper>
                  <p
                    style={{
                      color: "#000",
                      padding: "10px",
                    }}
                  >
                    <FormattedMessage
                      id="noBookingFound"
                      defaultMessage="No Bookings found"
                    />
                  </p>
                </Paper>
              )}
            </div>
          </div>
        </div>
        {bookingData.length > 0 && (
          <div className="text-center">
            {this.state.showScroll && this.renderScrollIcon()}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ bookings }) => {
  return {
    bookingData: bookings.bookingData.bookingList,
    bookingLoader: bookings.bookingLoader,
  };
};
const composedComponent = compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    actions
  )
);
export default composedComponent(withRouter(injectIntl(BookingList)));



// WEBPACK FOOTER //
// ./src/components/Providers/BookingList.jsx